import { Inject, ModuleWithProviders, NgModule, Type } from '@angular/core';
import {
    SEARCH_RESOURCE,
    SEARCH_RESOURCE_NAMESPACE,
    SEARCH_RESOURCE_USE_SELF,
    SearchResource,
} from './search-resource';
import { SearchEffects } from './search.effects';
import { SearchService } from './search.service';
import { createSearchNamespace } from './search.actions';
import { Store } from '@ngrx/store';

@NgModule()
export class SearchModule {
    static forFeature(
        namespace: string,
        resource: Type<SearchResource<any>>,
        self = false
    ): ModuleWithProviders<SearchModule> {
        return {
            ngModule: SearchModule,
            providers: [
                { provide: SEARCH_RESOURCE_NAMESPACE, useValue: namespace },
                { provide: SEARCH_RESOURCE, useExisting: resource },
                { provide: SEARCH_RESOURCE_USE_SELF, useValue: self },
                SearchService,
            ],
        };
    }

    constructor(
        @Inject(SEARCH_RESOURCE) resource: SearchResource<any>,
        @Inject(SEARCH_RESOURCE_NAMESPACE) namespace: string,
        @Inject(SEARCH_RESOURCE_USE_SELF) self: boolean,
        searchEffects: SearchEffects,
        store: Store
    ) {
        store.dispatch(createSearchNamespace({ namespace, self }));
        searchEffects.registerResource(namespace, resource);
    }
}
